"use strict";
/*
 * Created on 09 04 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var ValidationResult_1 = require("../../../core/model/errors/ValidationResult"); // tslint:disable:max-classes-per-file

/**
 * <p>Data transfer object (persisted) which encapsulates metadata and executive data for termination of regular prices set on sites.
 * Instance of this entity are created after successful upload.</p>
 *
 * @author Jaroslav Sevcik
 * @author JMe
 */


var SiteReleaseTerminationItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SiteReleaseTerminationItem, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id
   * @param terminationId Corresponds to {@link SiteReleaseTermination.id}.
   * @param pExtId Corresponds to {@link Product.externalId}.
   * @param pId Corresponds to {@link Product.id}.
   * @param pName Corresponds to {@link Product.productName}.
   * @param sExtId Corresponds to {@link InternalSite.externalId}.
   * @param sId Corresponds to {@link InternalSite.id}.
   * @param sName: Corresponds to {@link InternalSite.name}.
   * @param pValidTo The end date at which price should be ended. Value of the field is uploaded by user but user can still edit this
   *        field later on. Value cannot be in the past.
   * @param readonly Declares whether record is editable. If not, true is set, false otherwise.
   * @param terminate The flag which determines whether price should be terminated. Default value of all items is set to true.
   * @param validation The wrapper of all (user) related alerts, which resulted from validations.
   * @param exportResult The wrapper of all alerts related to result of an export. The result is updated asynchronously.
   */
  function SiteReleaseTerminationItem(id, terminationId, pExtId, pId, pName, sExtId, sId, sName, pValidTo, readonly, terminate, validation, exportResult) {
    var _this;

    _classCallCheck(this, SiteReleaseTerminationItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationItem).call(this));
    _this.id = id;
    _this.terminationId = terminationId;
    _this.pExtId = pExtId;
    _this.pId = pId;
    _this.pName = pName;
    _this.sExtId = sExtId;
    _this.sId = sId;
    _this.sName = sName;
    _this.pValidTo = pValidTo;
    _this.readonly = readonly;
    _this.terminate = terminate;
    _this.validation = validation;
    _this.exportResult = exportResult;
    return _this;
  }

  return SiteReleaseTerminationItem;
}(DomainObject_1.DomainObject);

exports.SiteReleaseTerminationItem = SiteReleaseTerminationItem;

SiteReleaseTerminationItem.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SiteReleaseTerminationItem.name);
  return {
    id: builder.id('id'),
    terminationId: builder.str('terminationId'),
    pExtId: builder.str('pExtId'),
    pId: builder.str('pId'),
    pName: builder.str('pName'),
    sExtId: builder.str('sExtId'),
    sId: builder.str('sId'),
    sName: builder.str('sName'),
    pValidTo: builder.date('pValidTo'),
    rName: builder.str('rName'),
    readonly: builder.bool('readonly'),
    terminate: builder.bool('terminate'),
    validation: builder.obj('validation', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    }),
    exportResult: builder.obj('exportResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();